import { useState, useContext, useEffect, useRef, useMemo } from "react"
import logo from '../img/logo.png'

import light from '../img/light.png'
import dark from '../img/dark.png'

import light_s from '../img/light-s.png'
import dark_s from '../img/dark-s.png'
import preheat from '../img/preheat.png'
import { Context, Hooks, XtLocale, Util, Config, Storage, Request } from "@xt/xtbase";

const LIVEHELP100_URL = "https://j5wxcf.7mmon3ss.com/chatwindow.aspx?siteId=65001365&planId=e146e265-fd7b-4e13-a3d3-76908e2394b3";

const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
const { getUrl, getQuery, getOrigin } = Util;
const { XtAxios } = Request;
import styles from "../index.module.less";
import IconXiala01 from "../img/icon/xiala-01";
import mbMartket from "../img/mb-market.png";
import mbTrade from "../img/mb-trade.png";
import mbDerivatives from "../img/mb-derivatives.png";
import mbCopy from "../img/mb-copy.png";
import mbFinance from "../img/mb-finance.png";
import mbListing from "../img/mb-listing.png";
import mbNft from "../img/mb-nft.png";
import mb5years from "../img/mb-5years.png";
import IconMoreMb from "../img/icon/moremb";
import IconGerenMb from "../img/icon/gerenmb";
import IconCustomerService from "../img/icon/customer-service";
import IconMessage from "../img/icon/message";
import spikexHomeLogo from "../img/spikex-home-logo.png";
import searchFIcon from "../img/icon/search-f";
import mbSecurity from "../img/mb-security.png";
import mbWallet from "../img/mb-wallet.png";
import mbOrder from "../img/mb-order.png";
import mbNotice from "../img/mb-notice.png";
import mbMore from "../img/mb-more.png";
import mbXiazai from "../img/mb-xiazai.png";
import mbLang from "../img/mb-lang.png";
import mbCurrency from "../img/mb-currency.png";
import mbSubAccount from "../img/mb-subaccount.png";
import { resolveCfdSymbol } from "../utils/getCfdSymbol";
import { useNavStore } from "../NavStoreContext";
import { observer } from "mobx-react-lite";

function NavbarMb(props) {

  const [appState] = useContext(XtContext);
  const { fund } = useNavStore();
  const { lang, theme, currency, userInfo, authInfo } = appState;
  const t = useTranslation()
  const langAry = XtLocale.localeList;

  const [visible, setVisible] = useState(false);
  const [openList, setOpenList] = useState(false);
  const [letterUnreadNum, setLetterUnreadNum] = useState(0);
  const letterPollTimerRef = useRef(null);

  const [loginQuery, setLoginQuery] = useState("");
  const isLogin = !!(authInfo || (userInfo && userInfo.userId));

  const [spotMarket, setSpotMarket] = useState("btc_usdt");
  const [leverMarket, setLeverMarket] = useState("btc_usdt");
  const [cfdMarket, setCfdMarket] = useState("btc_usdt_cfd");
  const [etfMarket, setEtfMarket] = useState("btc3l_usdt");
  const [etfIndexMarket, setEtfIndexMarket] = useState("index-btc_usdt");

  const recommendedCurrencyKey = useMemo(() => {
    return (fund?.recommendedCurrencyList || [])
      .map((item) => `${item?.currency || ""}:${(item?.plates || []).join(",")}`)
      .join("|");
  }, [fund?.recommendedCurrencyList, fund?.recommendedCurrencyListMd5]);

  useEffect(()=>{
    setSpotMarket(Storage.get("market") || spotMarket);
    setLeverMarket(Storage.get("leverMarket") || leverMarket);

    resolveCfdSymbol({
      fiatCurrencyIds: userInfo?.fiatCurrencyIds,
      loginStatus: appState.loginStatus,
    }).then((symbol) => {
      setCfdMarket(symbol);
    });

    setEtfMarket(Storage.get("etfMarket") || etfMarket);
    setEtfIndexMarket(Storage.get("etfIndexMarket") || etfIndexMarket);
    const ref = getQuery("ref");
    setLoginQuery("?backurl="+encodeURIComponent(location.href)+(ref?"&ref="+ref:""));
  }, [userInfo?.fiatCurrencyIds, appState.loginStatus, recommendedCurrencyKey]);

  // 与 @xt/Notify 一致：使用 letter-notice 接口与 autoSpotNotifyLocal 存储判断“新消息”
  const AUTO_SPOT_NOTIFY_LOCAL_KEY = "autoSpotNotifyLocal";
  const LETTER_NOTICE_PARAMS = { pushPage: 1, pageSize: 20, pageIndex: 1 };

  const getStoredTime = () => {
    try {
      const raw = localStorage.getItem(AUTO_SPOT_NOTIFY_LOCAL_KEY);
      if (!raw) return null;
      const { time } = JSON.parse(raw);
      return typeof time === "number" ? time : null;
    } catch (e) {
      return null;
    }
  };
  const getNewCount = (list, storedTime) => {
    if (!list || !list.length) return 0;
    if (storedTime == null) return list.length;
    return list.filter((item) => item.createTime >= storedTime).length;
  };

  /** 与 Notify AutoNoti 一致：写入“已读”时间，用于下次判断是否为新消息 */
  const setStoredTimeNow = () => {
    try {
      localStorage.setItem(AUTO_SPOT_NOTIFY_LOCAL_KEY, JSON.stringify({ value: 1, time: Date.now() }));
    } catch (e) {}
    setLetterUnreadNum(0);
  };

  useEffect(() => {
    if (!isLogin) {
      setLetterUnreadNum(0);
      return;
    }
    const fetchNoticeList = () => {
      const lang = (XtLocale.intl && XtLocale.intl.locale) || "en";
      XtAxios.get(getOrigin("www") + "/xt-message/public/letter-notice/list", {
        params: { ...LETTER_NOTICE_PARAMS, lang },
        isAutoPopError: false,
      })
        .then((list) => {
          if (Array.isArray(list)) {
            const time = getStoredTime();
            setLetterUnreadNum(getNewCount(list, time));
          }
        })
        .catch(() => {})
        .finally(() => {
          letterPollTimerRef.current = setTimeout(fetchNoticeList, 10000);
        });
    };
    fetchNoticeList();
    return () => {
      if (letterPollTimerRef.current) clearTimeout(letterPollTimerRef.current);
    };
  }, [isLogin]);

  const handleListToggle = (list) => {
    setOpenList(openList === list ? "" : list)
  }

  const close = () => {
    setVisible(false)
  }

  const changeVisible = () => {
    setVisible(!visible)
  }

  // 打开 LiveHelp100 在线客服（已替换原 Zendesk widget）
  const openCustomerService = () => {
    window.open(LIVEHELP100_URL, "_blank", "width=800,height=600,scrollbars=yes,resizable=yes");
  }

  /** 顶栏搜索入口文案：仅在 en / ar / pt 语言包维护 header.navSearch */
  const navSearchLabel = t("header.navSearch") || "Search";

  return (
    <div className={styles['app-navbar-mb']}>
      {/* 左侧：品牌 Logo，点击进入个人中心 */}
      <div className={styles['mb-nav-left']}>
        <a href={getUrl("/accounts/user/overview")} className={styles['mb-avatar-link']}>
          <img
            src={spikexHomeLogo}
            alt=""
            className={styles["mb-home-logo"]}
            width={32}
            height={32}
            draggable={false}
          />
        </a>
      </div>

      {/* 中间：设计稿 light/search/default，点击进入搜索页 */}
      <a
        href={getUrl("/search")}
        className={styles["mb-nav-search"]}
        aria-label={navSearchLabel}
      >
        <span className={styles["mb-nav-search-inner"]}>
          <img
            src={searchFIcon}
            alt=""
            className={styles["mb-nav-search-icon"]}
            width={16}
            height={16}
            draggable={false}
          />
          <span className={styles["mb-nav-search-placeholder"]}>
            {navSearchLabel}
          </span>
        </span>
      </a>

      {/* 右侧：客服、消息（Figma Frame 1312315482：图标 20×20，间距 20px） */}
      <div className={styles['mb-nav-right']}>
        {/* More 图标 - 打开导航栏 */}
        {/* <a 
          tabIndex="0" 
          className={`${styles['mb-nav-icon']} ${styles.menu_mb}`} 
          onClick={changeVisible}
        >
          <IconMoreMb style={{ width: "20px", height: "20px", color: "white" }} />
        </a> */}

        {/* 客服图标 */}
        <div 
          className={styles['mb-nav-icon']}
          onClick={openCustomerService}
          style={{ cursor: 'pointer' }}
        >
          <IconCustomerService style={{ width: "20px", height: "20px", color: "white" }} />
        </div>

        {/* 消息图标：有未读站内信时显示小红点（已登录才拉取；点击时写入 autoSpotNotifyLocal） */}
        <a
          href={getUrl("/notification")}
          className={styles['mb-nav-icon']}
          style={{ textDecoration: "none" }}
          onClick={setStoredTimeNow}
        >
          <span style={{ position: "relative", display: "inline-flex" }}>
            <IconMessage style={{ width: "20px", height: "20px", color: "white" }} />
            {letterUnreadNum > 0 ? <i className={styles["mb-nav-msg-dot"]} /> : null}
          </span>
        </a>
      </div>

      {
        visible && (
          <div name="app-navbar-mb__menu">
            <div className={styles["app-navbar-mb__menu"]} onClick={close}>
              <div onClick={(e) => e.stopPropagation()}>
                <div style={{ "paddingBottom": "14px" }}>
                  <XtAuth renderLogin={() => {
                    return <a tabIndex="0" className={styles.iBtn} onClick={() => { props.doLogout() }}>{t("header.safelyLogout")}</a>
                  }} renderNotLogin={() => {
                    return <div>
                      <a href={getUrl("/accounts/login"+loginQuery)} className={styles.iBtn}>{t("header.login")}</a>
                      <a href={getUrl("/accounts/register"+loginQuery)} className={`${styles.iBtn} ${styles.iBtnFull}`}>{t("header.signUp")}</a>
                    </div>
                  }}></XtAuth>
                </div>
                <div className={styles.iGroup}>
                  <a href={getUrl("/aicopy")}>
                    <span>{t("header.aicopy")}</span>
                  </a>
                </div>
                <div className={styles.iGroup}>
                  <a href={getUrl("/market")}>
                    <span>{t("header.markets")}</span>
                  </a>

                  <div className={`${styles.iList} ${openList === 'trade' ? styles.atv : ''}`}>
                    <a onClick={() => handleListToggle('trade')}>
                      <span>{t("header.trading")}</span>
                      <IconXiala01 className={`${styles['iconxiala-01']}`}/>
                    </a>
                    <div>
                      <a href={getUrl("/futures/contract/" + cfdMarket)}>
                        <span>{t("header.spotTrading")}</span>
                      </a>
                      <a href={getUrl("/futures/contract/" + cfdMarket)}>
                        <span>{t("header.cfdTrading")}</span>
                      </a>
                      {/* {authInfo && authInfo.country && authInfo.country.code != "971" ? <a href={getUrl("/trade/" + leverMarket + "?type=margin")}>
                        <span>{t("header.marginTrading")}</span>
                      </a> : null} */}
                      {/*<a href={getUrl("/trade/" + spotMarket)}>*/}
                      {/*  <span>{t("header.spot")}</span>*/}
                      {/*</a>*/}
                      {/*<a href={getUrl("/tradePro/" + spotMarket)}>*/}
                      {/*  <span>{t("header.spotPro")}</span>*/}
                      {/*</a>*/}
                      {/*<a href={getUrl("/margin/" + leverMarket)}>*/}
                      {/*  <span>{t("header.lever")}</span>*/}
                      {/*</a>*/}
                      {/*<a href={getUrl("/margin/" + leverMarket)}>*/}
                      {/*  <span>{t("header.leverPro")}</span>*/}
                      {/*</a>*/}
                    </div>
                  </div>

                  <div className={`${styles.iList} ${openList === 'otc' ? styles.atv : ''}`}>
                    <a onClick={() => handleListToggle('otc')}>
                      <span>{t("header.buyCrypto")}</span>
                      <IconXiala01 className={`${styles['iconxiala-01']}`}/>
                    </a>
                    <div>
                      <a href={getUrl("/credit/debitCard")}>
                        <span>{t('header.tipThird')}</span>
                      </a>
                    </div>
                  </div>

                  {/* <div className={`${styles.iList} ${openList === 'finance' ? styles.atv : ''}`}>
                    <a onClick={() => handleListToggle('finance')}>
                      <span>{t("header.finance")}</span>
                      <IconXiala01 className={`${styles['iconxiala-01']}`}/>
                    </a>
                    <div>
                      <a href={getUrl("/finance/simple-earn")}>
                        <span>{t("header.FinanceSimpleEarn")}</span>
                      </a>
                      <a href={getUrl("/finance/savings")}>
                        <span>{t("header.FinanceSavings")}</span>
                      </a>
                      <a href={getUrl("/finance/staking")}>
                        <span>{t("header.FinanceStaking")}</span>
                      </a>
                    </div>
                  </div> */}

                  {/* <a href={getUrl("/listing")}>
                    <span>{t("header.list")}</span>
                  </a> */}
                </div>

                <XtAuth renderLogin={(userInfo)=>{
                  return <div className={styles.iGroup}>
                    <a href={getUrl("/account/index")}>
                      <span>{t("header.securityCenter")}</span>
                    </a>
                    <div className={`${styles.iList} ${openList === 'fund' ? styles.atv : ''}`}>
                      <a className={/^\/wallet\/account($|[\/\?#])/.test(location.pathname) ? styles.atv : ''} onClick={() => handleListToggle('fund')}>
                        <span>{t("header.asset")}</span>
                        <IconXiala01 className={`${styles['iconxiala-01']}`}/>
                      </a>
                      <div>
                        <a href={getUrl("/wallet/account/overview")}>
                          <span>{t("header.overview")}</span>
                        </a>
                        <a href={getUrl("/wallet/account/spot")}>
                          <span>{t("header.SpotAccount")}</span>
                        </a>
                        {/* {authInfo && authInfo.country && authInfo.country.code != "971" ? <a href={getUrl("/wallet/account/margin")}>
                          <span>{t("header.marginAccount")}</span>
                        </a> : null} */}
                        <a href={getUrl("/wallet/account/finance")}>
                          <span>{t("header.FinanceAccount")}</span>
                        </a>
                      </div>
                    </div>
                    <div className={`${styles.iList} ${openList === 'order' ? styles.atv : ''}`}>
                      <a className={/^\/orders($|[\/\?#])/.test(location.pathname) ? styles.atv : ''} onClick={() => handleListToggle('order')}>
                        <span>{t("header.order")}</span>
                        <IconXiala01 className={`${styles['iconxiala-01']}`}/>
                      </a>
                      <div>
                        <a href={getUrl("/orders/spot/openorder")}>
                          <span>{t("header.spotOrder")}</span>
                        </a>
                        {/* {authInfo && authInfo.country && authInfo.country.code != "971" ? <a href={getUrl("/orders/margin/openorder")}>
                          <span>{t("header.leverOrder")}</span>
                        </a> : null} */}
                        <a href={getUrl("/orders/finance/openorder")}>
                          <span>{t("header.financeOrder")}</span>
                        </a>
                      </div>
                    </div>
                    <a href={getUrl("/notification")} onClick={setStoredTimeNow}>
                      <span>{t("header.noticeCenter")}</span>
                    </a>
                  </div>
                }}></XtAuth>

                <div className={styles.iGroup}>
                  <div className={`${styles.iList} ${openList === 'more' ? styles.atv : ''}`}>
                    <a onClick={() => handleListToggle('more')}>
                      <span>{t("header.more")}</span>
                      <IconXiala01 className={`${styles['iconxiala-01']}`}/>
                    </a>
                    <div>
                      <a href={getUrl("/futures/contract/" + cfdMarket)}>
                        <span>Exchange</span>
                      </a>
                      {/* <a href={getUrl("/launchpad")}>
                        <span>Sigma Launchpad</span>
                      </a> */}
                      <a href={getUrl("/academy")}>
                        <span>Academy</span>
                      </a>
                      <a href={getUrl("/referral")}>
                        <span>{t("header.superPartner")}</span>
                      </a>
                      {/* <a href={getUrl("/schedule")}>
                        <span>{t("header.schedule")}</span>
                      </a> */}
                      <a href={getUrl("/affiliate")}>
                        <span>{t("header.affiliate")}</span>
                      </a>
                    </div>
                  </div>
                </div>

                <div className={styles.iGroup}>
                  <a href={getUrl("/app")}>
                    <span>{t("header.appDl")}</span>
                  </a>
                </div>

                <div className={styles.iGroup}>
                  <div className={`${styles.iList} ${openList === 'lang' ? styles.atv : ''}`}>
                    <a onClick={() => handleListToggle('lang')}>
                      <span>{langAry.find(item => lang === item.key).lab}</span>
                      <IconXiala01 className={`${styles['iconxiala-01']}`}/>
                    </a>
                    <div>
                      {
                        langAry.map((item) => (
                          <a
                            key={item.key}
                            tabIndex="0"
                            onClick={() => props.onLocale(item)}
                            className={`${lang === item.key ? styles.atv : ''}`}
                          >
                            {item.lab}
                          </a>
                        ))
                      }
                    </div>
                  </div>
                  <div className={`${styles.iList} ${openList === 'assist' ? styles.atv : ''}`}>
                    <a onClick={() => handleListToggle('assist')}>
                      <span>{t("header.currency")}</span>
                      <IconXiala01 className={`${styles['iconxiala-01']}`}/>
                    </a>
                    <div>
                      {
                        Config.assistConfig.map((item) => (
                          <a
                            key={item.key}
                            tabIndex="0"
                            onClick={() => props.onAssist(item)}
                            className={`${currency === item.key ? styles.atv : ''}`}
                          >
                            {item.name}
                          </a>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }

    </div>
  )
}
export default observer(NavbarMb);
